// removed by extract-text-webpack-plugin
module.exports = {"root":"root___11z25","card-container":"card-container___2bKQa"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/SkusEdit/Index.less
// module id = 867h
// module chunks = 10 11